/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * ---
 * category: utilities/utils
 * ---
 * Converts a CSS unit value combination into an array of type [ value, unit ]
 *
 * @module parseUnit
 *
 * Example inputs:
 *  - '100px'
 *  - '20rem'
 *  - '10vh'
 *  - '400vmin'
 *
 * @param {string|number} str
 * @returns {Array} Returns array of shape [ value, unit ] Unit is '' if it could
 * not be parsed
 */

function parseUnit(str) {
  const value = `${str}`;
  // eslint-disable-next-line no-useless-escape
  const match = value.match(/[\d.\-\+]*\s*(.*)/);
  return [parseFloat(value), match && match.length > 0 ? match[1] : ''];
}
export default parseUnit;
export { parseUnit };